import React from 'react';
import ProfilePage from './pages/ProfilePage.js';
import ListingPage from './pages/ListingPage.js';
import { Route } from 'react-router-dom';

// modules return fragments containing routes.
// passing the component as a prop ensures match params are passed in props
// see https://stackoverflow.com/questions/46197178/cannot-read-property-params-of-undefined-react-router-4

const ListingRedirect = ({history, match: {params: {listing_uuid}}}) => {
  history.replace('/listing/' + listing_uuid);
};

const routes = () => {
  return [
    <Route key="/provider/listing" exact path="/provider/:provider_uuid/listing/:listing_uuid" render={ListingRedirect} />,
    <Route key="/provider" exact path="/provider/:uuid" component={ProfilePage}/>,
    <Route key="/listing" path="/listing/:uuid" exact component={ListingPage}/>,
  ];
};

export default routes;
